import React,{Component} from 'react';
import _ from 'lodash';
import './App.css';
import {data} from './Data.js'; 
import {Camera3D} from './Camera3D.js';
import {Model3D} from './Model3D.js';
import { Vector3D } from './Vector3D.js';
import Image2D from './Image2D.js';

const INTERVAL = 30;

class App extends Component {
  state = {
    code: null,
  };
  camEye = [];
  camAt = new Vector3D(data.camAt[0],data.camAt[1],data.camAt[2]);

  constructor(props) {
    super(props);
    this.loadData();
    window.addEventListener("keydown",(e)=> {
      if (this.intervalId === null) {
        this.setState({code:e.code});
        this.onKey(e.code);
        this.mainLoop();
      }
    });
    window.addEventListener("keyup",()=> {
      this.setState({code:null});
    });
  }

  loadData() {
    data.camEye.forEach( function(val) {
      this.camEye.push([new Vector3D(val.pos[0],val.pos[1],val.pos[2]),val.angle]);
    }.bind(this));
    const eye = this.camEye[0];
    this.camera = new Camera3D(eye,this.camAt);
    this.preCam = eye;
    this.current = 0;
    this.count = 0.0;
    this.intervalId = null;
    this.model = [];
    data.imagePos.forEach( function(val) {
      const image = data.images[val.img];
      this.model.push(new Model3D(image.img,val.pos,image.size,val.cam));
    }.bind(this));
   }

  resize = _.debounce(() => {
    this.camera.perspective();
    this.mainLoop();
    this.setState({code:null});
  });

  componentDidMount() {
    window.addEventListener('resize',this.resize);
    this.mainLoop();
    this.setState({code:null});
  }

  componentWillUnmount() {
    window.removeEventListener('resize',this.resize);
    window.removeEventListener('keydown',this.resize);
    window.removeEventListener('keyup',this.resize);
    window.removeEventListener('mouseup',this.resize);
    if (this.intervalId !== null)
      clearInterval(this.intervalId);
  }

  onUp(e,current) {
    if ('touchend' in document) return;
    this.onTouch(e,current);
  }

  onTouch(e,current) {
    if (this.intervalId !== null
    || this.current === current)
      return;
    this.current = current;
    this.count = 0;
    if (this.intervalId != null)
      clearInterval(this.intervalId);
    this.intervalId = setInterval(() => {
      this.cameraMove();
      this.mainLoop();
      this.setState({code:this.state.code});
    },INTERVAL);
  }

  onKey(code) {
    switch (code) {
      case "ArrowLeft":
        this.camera.addRihgt(-10);
        break;
      case "ArrowRight":
        this.camera.addRihgt(10);
        break;
      case "ArrowUp":
        this.camera.forward(-10);
        break;
      case "ArrowDown":
        this.camera.forward(10);
        break;
      case "KeyA":
        this.camera.addAngle(-1);
        break;
      case "KeyD":
        this.camera.addAngle(1);
         break;
      case "KeyW":
        this.camera.addUp(10);
        break;
      case "KeyS":
        this.camera.addUp(-10);
        break;
      default: break;
    }
    this.preCam = this.camera.getCamera();
  }

  cameraMove() {
    const len = this.camEye.length;
    const p1 = this.camEye[0];
    const p2 = this.preCam;
    const p3 = this.camEye[this.current];
    const p4 = this.camEye[(this.current+1)%len];
    this.camera.interpolate(this.count,p1,p2,p3,p4);
    this.count += INTERVAL/1000;
    if (this.count > 1) {
      this.count = 1;
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.preCam = this.camEye[this.current];
    }
  }

  mainLoop() {
    this.camera.lookAt();
    for (let model of this.model) {
      model.getPosition(this.camera);
      model.getHeight(this.camera);
      model.centering();
    }
  }

  compareFunc(a, b) {
    return b.loc.z - a.loc.z;
  }

  render() {
    let array = [];
    this.model.sort(this.compareFunc);
    this.model.forEach((elm, idx) => {
      array.push(<Image2D parent={this} model={elm} key={idx} />);
    });
    if (this.intervalId == null) {
      array.push(<h1 key="-1">ThreeDwo</h1>);
      array.push(<h2 dangerouslySetInnerHTML={{__html:data.text[this.current]}} key="-2" />);
    }
    return <div className="App">
      {array}
    </div>
  }
}

export default App;
